import React from "react";
import { Header } from "components";
import { ReactSpinner } from "react-spinning-wheel";
import "./style.scss";
import NotificationsSystem, { atalhoTheme, useNotifications } from 'reapop'

interface Props {
	isSpinner?: boolean;
  children: React.ReactNode;
}

export const BasicLayout = ({ isSpinner, children }: Props) => {
  const { notifications, dismissNotification } = useNotifications();

  return (
    <div className="basic-layout">
      <NotificationsSystem
        notifications={notifications}
        dismissNotification={(id) => dismissNotification(id)}
        theme={atalhoTheme}
      />

      <Header />

      {children}
			{isSpinner != undefined && isSpinner  && (
				<div className="loader">
					<ReactSpinner />
				</div>
			)}
    </div>
  );
};
